import { PatientReferralData } from '@/common/types';
import { backendPost } from './BackendApi.ts';
import { objectToFormData } from '@/common/utilities/objectToFormData.ts';

export async function submitPatientReferral(data: {
  patient_referral: PatientReferralData;
}): Promise<void> {
  const formData = objectToFormData(data);
  await backendPost<FormData>('/patient_referrals', formData);
}
